export const roleMapper: { [key: string]: string } = {
  ADMIN: '사이트 관리',
  MANAGER: '일반',
  WORKER: '작업자',
} as const;
